import _ from "lodash";
import { useState } from "react";
import { DropdownItemProps, Dropdown, Label, Icon } from "semantic-ui-react";
import { DropdownOption } from "../../models/testing_model";

export function MultipleDropdownFilter<D>(props: {label: string, value: D[], options: DropdownItemProps[], onChange: (value: D[]) => void, search?: boolean | ((options: DropdownItemProps[], value: string) => DropdownItemProps[]), renderLabel?: (item: DropdownItemProps, index: number) => any, scrolling?: boolean, loading?:boolean}) {
    const {label, value, options, onChange, search, renderLabel, scrolling, loading} = props;

    return <Dropdown multiple 
        loading={loading}
        value={value as any}
        onChange={(e, d) => onChange(((d.value as any) as D[]).filter(v => !_.isNil(v) && !_.isNaN(v)))}
        search={search} scrolling={scrolling}
        renderLabel={renderLabel}
        trigger={<div style={{float: search ? 'left' : undefined, 'display': search ? undefined : 'inline-block', marginTop: '0.5rem'}}>{label}: &nbsp;</div>}
        options={options} className={`button mini icon ${!_.isEmpty(value) && 'yellow'}`} 
    />
}



export function DropdownFilter<D>(props: {label: string, value?: D, options: DropdownItemProps[], onChange: (value: D) => void, search?: boolean | ((options: DropdownItemProps[], value: string) => DropdownItemProps[]), renderLabel?: (item: DropdownItemProps) => any, scrolling?: boolean}) {
    const {label, value, options, onChange, search, scrolling} = props;

    const isValueNotEmpty = !_.isNil(value) && !_.isNaN(value);
    const selected = isValueNotEmpty ? options.find(o => o.value === value) : null;
    const selectedText = selected ? <Label as="a" size="mini">{selected.text}</Label> : null;
    return <Dropdown search={search} value={value as any} 
        options={isValueNotEmpty ? options.map(o => _.isUndefined(o.value) ? ({...o, content: <Icon name="delete"> Empty</Icon>}) : o) : options}
        onChange={(e, d) => onChange((d.value as any) as D)}
        trigger={<><div className="divider text">{label}: &nbsp;</div>{selectedText}</>}
        className={`multiple button mini icon ${isValueNotEmpty && 'yellow'}`}
        scrolling={scrolling}
    />
}


export function TestingResultDropdown(props: {name: string, value: number, options: DropdownOption[], onChange: (e: any, d: any) => void, placeholder?: string}) {
    const {name, value, options, onChange, placeholder} = props;
    let selectedTestingResult = placeholder || 'Please Select';
    if (value) {
        out: for (const p of options) {
            for (const s of p.children) {
                for (const o of s.children) {
                    if (o.id === value) {
                        selectedTestingResult = `${p.name} -> ${s.name} -> ${o.name}`;
                        (window as any).test_info = {product: p.name, order: s.name}
                        window.document.title = selectedTestingResult;
                        break out;
                    }
                }
            }
        }
    }

    return <Dropdown button compact text={selectedTestingResult}>
        <Dropdown.Menu>
            {options.map(p => <Dropdown.Item key={p.id} className="project-menu-item">
                <Dropdown text={p.name} compact>
                    <Dropdown.Menu direction="right">
                        {p.children.map(s => <Dropdown.Item key={s.id} className="project-menu-item">
                            <Dropdown text={s.name} compact>
                                <Dropdown.Menu direction="right">
                                    {s.children.map(o => <Dropdown.Item key={o.id} onClick={e => {
                                        e.preventDefault();
                                        onChange(null, {name, value: o.id});
                                    }}>{o.name}</Dropdown.Item>)}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Dropdown.Item>)}
                    </Dropdown.Menu>
                </Dropdown>
            </Dropdown.Item>)}
        </Dropdown.Menu>
    </Dropdown>
}